/* eslint-disable prefer-arrow-callback, consistent-return, array-callback-return, no-else-return */
import axios from 'axios'
import countries from 'countries-list/dist/countries.emoji.min.json'
import _, { get } from 'lodash'
import salesTax from 'sales-tax/res/sales_tax_rates.json'

const COUNTRIES_TO_EXCLUDE = [
  'U.S. Minor Outlying Islands',
  'Antarctica',
  'Aruba',
  'Bouvet Island',
  'Heard Island and McDonald Islands',
  'Åland',
  'Saint Barthélemy',
  'Bonaire',
  'Cocos [Keeling] Islands',
  'Cook Islands',
  'Cape Verde',
  'Curacao',
  'Christmas Island',
  'Western Sahara',
  'Falkland Islands',
  'Faroe Islands',
  'French Guiana',
  'Guernsey',
  'Gibraltar',
  'Greenland',
  'Guadeloupe',
  'South Georgia and the South Sandwich Islands',
  'Guam',
  'Isle of Man',
  'British Indian Ocean Territory',
  'Cayman Islands',
  'Saint Martin',
  'Northern Mariana Islands',
  'Martinique',
  'Montserrat',
  'Niue',
  'French Polynesia',
  'Saint Pierre and Miquelon',
  'Pitcairn Islands',
  'Puerto Rico',
  'Réunion',
  'Svalbard and Jan Mayen',
  'Sint Maarten',
  'Turks and Caicos Islands"',
  'French Southern Territories',
  'Tokelau',
  'British Virgin Islands',
  'U.S. Virgin Islands',
  'Wallis and Futuna',
  'Mayotte',
]

export const countriesList = Object.keys(countries)
  .reduce((acc, c) => {
    acc.push({
      code: c,
      currency: countries[c].currency,
      emoji: countries[c].emoji,
      label: countries[c].name,
      phone: countries[c].phone,
      value: countries[c].name,
    })
    return acc
  }, [])
  .filter(country => !COUNTRIES_TO_EXCLUDE.includes(country.value))

export const getCountryCode = country => {
  const countryObject = countriesList.find(item => {
    if (item.value === country) {
      return item.code
    }
  })

  if (countryObject) {
    return countryObject.code
  }

  return country
}

export const getCountryData = country => {
  const countryObject = countriesList.find(item => {
    if (item.value === country) {
      return item.code
    }
  })
  if (countryObject) {
    return countryObject
  }

  return country
}

export const getCountryByCode = code => {
  const countryObject = countriesList.find(item => {
    if (item.code === code) {
      return item.code
    }
  })
  if (countryObject) {
    return countryObject
  }

  return code
}

export const getCountries = (selectedCountries, includeExclude, sortBy, hierarchyCountryCode) => {
  /* eslint-disable-next-line prefer-const */
  const sort = sortBy || 'label'
  let countriesSorted = _.orderBy(countriesList, sort, 'asc')

  if (hierarchyCountryCode) {
    const hierarchyCountry = countriesSorted.find(c => c.code === hierarchyCountryCode)
    const otherCountries = countriesSorted.filter(c => c.code !== hierarchyCountryCode)

    if (hierarchyCountry) {
      countriesSorted = [hierarchyCountry, ...otherCountries]
    }
  }

  if (selectedCountries) {
    return countriesSorted.filter(item => {
      if (includeExclude === 'include') {
        return selectedCountries.indexOf(item.code) !== -1
      } else if (includeExclude === 'exclude') {
        return selectedCountries.indexOf(item.code) === -1
      }
    })
  }

  return countriesSorted
}

export function getCountryValues(type) {
  const countries = getCountries()
  /* eslint-disable-next-line prefer-const */
  const countryList = []
  let countryData = [{}]

  if (type === 'dropdown') {
    _.map(countries, country =>
      countryList.push({
        id: country.value,
        name: country.value,
      })
    )
    countryData = [
      {
        key: 'country',
        value: countryList,
        key_prefix: '',
      },
    ]
  } else if (type === 'selectautocomplete') {
    _.map(countries, country =>
      countryList.push({
        label: country.value,
        value: country.value,
      })
    )
    countryData = [
      {
        key: 'country',
        value: countryList,
        key_prefix: '',
      },
    ]
    countryData = countryData[0].value
  }

  return countryData
}

export function getSubdivisions(country, url) {
  return new Promise((resolve, reject) => {
    const request = {
      url: url.replace('{country}', country),
      method: 'get',
    }

    axios(request)
      .then(response => {
        if (response.status < 300) {
          return resolve(get(response, 'data.data.rows') || [])
        }
        reject(new Error(get(response, 'data.error') || 'Something went wrong'))
      })
      .catch(() => {
        reject(new Error('Something went wrong'))
      })
  })
}

export const getCountrySalesTax = country => {
  const countryCode = getCountryCode(country)

  if (countryCode === 'US') {
    return 'Sales and Use Tax'
  }

  // 'sales-tax' library has incorrect NZ type value
  // temporary override until library is updated
  // submitted a PR to main repo for consideration: https://github.com/valeriansaliou/node-sales-tax/pull/50
  if (countryCode === 'NZ') {
    return 'GST'
  }

  const { type } = salesTax[countryCode] || {}
  return type ? String(type).toUpperCase() : 'tax'
}
